import { Button } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { ASSETS_PATH } from "./../constants";
import { uploadAsset } from "./../utilities/assetUtils";
import CircularWithValueLabel from "./../components/CircularWithValueLabel";


const PopLanguagesVideo = ({videos={}, onSetVideos, onVideosPopClose}) => {

    const [vids, setVids] = useState(videos);

    const [availableLangs, setAvailableLangs] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/language`, { method: 'GET' })
            .then((res) => res.json())
            .then((json) => {
                console.log(json);
                const ls = json.languages;
                ls.unshift({language:"English", language_slug:"english"})
                setAvailableLangs(json.languages)
            });
    }, [])

    const onUploadNarration = (e, lang) => {
        uploadAsset(e, (fileName) => { setVids(prev => { return { ...prev, [lang]:{...prev[lang], video:fileName}} }) }, setUploading, setProgress)
        console.log(vids);
    }

    const onRemoveNarration = (lang) => {
        setVids(prev => { return { ...prev, [lang]:{...prev[lang], video:""}} });
    }


    const onUploadSubtitle = (e, lang) => {
        uploadAsset(e, (fileName) => { setVids(prev => { return { ...prev, [lang]:{...prev[lang], subtitle:fileName}} }) }, setUploading, setProgress)
        console.log(vids);
    }

    const onRemoveSubtitle = (lang) => {
        setVids(prev => { return { ...prev, [lang]:{...prev[lang], subtitle:""}} });
    }

    return (
        <>
        <div className="pop-naration" id="pop-naration">
            <div className="pop-background"></div>
            <div className="pop-container">
                <div className="pop-header">
                    Upload Narations in other languages
                </div>
                <div className="pop-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    {
                        availableLangs.map((l, index) =>
                            <Fragment key={index}>
                                <br />
                                <div className="flex flex-row gap-4">
                                    <div className="w-28">{l.language}</div>
                                    {(!vids[l.language_slug] || !vids[l.language_slug].video ||vids[l.language_slug].video.trim() === "") &&
                                        <>
                                        <Button
                                        variant="contained"
                                        component="label"
                                    >
                                        Upload Video
                                        <input
                                            type="file"
                                            hidden
                                            onChange={(e) => onUploadNarration(e, l.language_slug)}
                                        />
                                    </Button>
                                        </>
                                    }
                                    
                                    {vids[l.language_slug] && vids[l.language_slug].video &&vids[l.language_slug].video.trim() !== "" &&
                                        <>
                                            <div>
                                                {vids[l.language_slug].video}

                                            </div>
                                            <Button
                                                onClick={() => onRemoveNarration(l.language_slug)}
                                            >
                                                Remove Video

                                            </Button>
                                        </>
                                    }



                                    {(!vids[l.language_slug] || !vids[l.language_slug].subtitle || vids[l.language_slug].subtitle.trim() === "") &&
                                        <>
                                        <Button
                                        variant="contained"
                                        component="label"
                                    >
                                        Upload Subtitle
                                        <input
                                            type="file"
                                            hidden
                                            onChange={(e) => onUploadSubtitle(e, l.language_slug)}
                                        />
                                    </Button>
                                        </>
                                    }
                                    
                                    {vids[l.language_slug] && vids[l.language_slug].subtitle && vids[l.language_slug].subtitle.trim() !== "" &&
                                        <>
                                            <div>{vids[l.language_slug].subtitle.trim()}</div>
                                            <Button
                                                onClick={() => onRemoveSubtitle(l.language_slug)}
                                            >
                                                Remove Subtitle

                                            </Button>
                                        </>
                                    }

                                </div>
                                <br />
                            </Fragment>
                        )
                    }
                </div>
                <div className="pop-footer flex flex-row">
                    <Button onClick={() => onSetVideos(vids)}>Update and Close</Button>
                    <Button onClick={onVideosPopClose}>Close</Button>
                </div>
            </div>
        </div>
        {uploading && <CircularWithValueLabel progress={progress} />}
        </>
    )
}

export default PopLanguagesVideo;